import { defineComponent as _defineComponent } from 'vue'
import { ref, defineEmits } from "../TUIKit/adapter-vue";
import TUIChatEngine, {
  TUITranslateService,
  TUIUserService,
  TUIStore,
  StoreName,
} from "@tencentcloud/chat-uikit-engine";
import dayjs, { Dayjs } from "dayjs";
import { Toast, TOAST_TYPE } from "../TUIKit/components/common/Toast/index";
import EditProfilePopup from "./EditProfilePopup.vue";
import DatePicker from "../TUIKit/components/common/DatePicker";
import Avatar from "../TUIKit/components/common/Avatar/index.vue";
import Icon from "../TUIKit/components/common/Icon.vue";
import backSVG from "../TUIKit/assets/icon/back.svg";
import rightArrowIcon from "../TUIKit/assets/icon/right-icon.svg";
import calendarSVG from "../assets/icon/calendar.svg";
import { IUserProfile } from "../TUIKit/interface";
import { isH5, isPC } from "../TUIKit/utils/env";
import { enableSampleTaskStatus } from "../TUIKit/utils/enableSampleTaskStatus";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditProfile',
  emits: ["closeEditProfileBox"],
  setup(__props, { emit: emits }) {


// config
const avatarListBaseUrl = "https://im.sdk.qcloud.com/download/tuikit-resource/avatar/avatar_";
const avatarList = ["1.png", "2.png", "3.png", "4.png", "5.png", "6.png"].map(
  (url: string) => avatarListBaseUrl + url
);
const genderLabelList: {
  [propsName: string]: string;
} = {
  [TUIChatEngine.TYPES.GENDER_MALE]: "男",
  [TUIChatEngine.TYPES.GENDER_FEMALE]: "女",
  [TUIChatEngine.TYPES.GENDER_UNKNOWN]: "不显示",
};
const userProfile = ref<IUserProfile>({});
// current edit value
const currentEditProfile = ref<IUserProfile>({
  avatar: userProfile.value?.avatar,
  nick: userProfile.value?.nick,
  selfSignature: userProfile.value?.selfSignature,
  gender: userProfile.value?.gender,
  birthday: userProfile.value?.birthday,
});
const birthdayObj = ref<{ obj: typeof Dayjs; format: string; value: number }>({});
const currentBottomPopupShow = ref<string>("");

TUIStore.watch(StoreName.USER, {
  userProfile: (userProfileData: IUserProfile) => {
    userProfile.value = userProfileData;
    const { avatar, nick, selfSignature, gender, birthday } = userProfileData;
    currentEditProfile.value = { avatar, nick, selfSignature, gender, birthday };
    birthdayObj.value = generateBirthdayObj(userProfileData.birthday);
  },
});

function generateBirthdayObj(YYYYMMDD: any) {
  let birthdayDayjsObj: typeof Dayjs = null;
  let birthdayFormat = "";
  if (YYYYMMDD && typeof YYYYMMDD === "number") {
    birthdayDayjsObj = dayjs(YYYYMMDD.toString(), "YYYYMMDD");
    birthdayFormat = birthdayDayjsObj.format("YYYY/MM/DD");
  }
  return {
    obj: birthdayDayjsObj,
    format: birthdayFormat,
    value: userProfile.value?.birthday || 0,
  };
}

function showBottomPopup(key: string) {
  currentBottomPopupShow.value = key;
}
function closeBottomPopup() {
  currentBottomPopupShow.value = "";
}

function pickBirthday(date: typeof Dayjs) {
  currentEditProfile.value.birthday = parseInt(date.format("YYYYMMDD"), 10);
}

function changeCurrentEditProfile(key: keyof IUserProfile, value: any) {
  if (Object.prototype.hasOwnProperty.call(currentEditProfile.value, key)) {
    currentEditProfile.value[key] = value;
  }
}

function closeEditProfileBox() {
  emits("closeEditProfileBox");
}

function submitEditProfileBox() {
  let isNickModified = currentEditProfile.value.nick !== userProfile.value.nick;
  const profileOptions = Object.fromEntries(
    Object.entries(currentEditProfile.value).filter(([key, value]) => {
      return value !== null && value !== undefined && value !== "";
    })
  );
  TUIUserService.updateMyProfile(profileOptions)
    .then(() => {
      isNickModified && enableSampleTaskStatus("modifyNickName");
      Toast({
        message: TUITranslateService.t("Profile.修改个人资料成功"),
        type: TOAST_TYPE.SUCCESS,
      });
      isPC && closeEditProfileBox();
    })
    .catch((error: Error) => {
      Toast({
        message: TUITranslateService.t("Profile.修改个人资料失败") + error?.message,
        type: TOAST_TYPE.ERROR,
      });
      isPC && closeEditProfileBox();
    });
}

return { __sfc: true,emits, avatarListBaseUrl, avatarList, genderLabelList, userProfile, currentEditProfile, birthdayObj, currentBottomPopupShow, generateBirthdayObj, showBottomPopup, closeBottomPopup, pickBirthday, changeCurrentEditProfile, closeEditProfileBox, submitEditProfileBox, TUITranslateService, EditProfilePopup, DatePicker, Avatar, Icon, backSVG, rightArrowIcon, calendarSVG, isH5, isPC }
}

})